var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgAppSetupBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1106,
    height: 336,
    viewBox: "0 0 1106 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12983_5150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1106,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1106,
    height: 336,
    rx: 20,
    fill: "url(#paint0_linear_12983_5150)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12983_5150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.982422,
    width: 1106,
    height: 336,
    rx: 20,
    fill: "url(#paint1_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.242 162.6C471.233 162.6 536.89 95.7561 536.89 13.3C536.89 -69.1561 471.233 -136 390.242 -136C309.25 -136 243.594 -69.1561 243.594 13.3C243.594 95.7561 309.25 162.6 390.242 162.6Z",
    fill: "url(#paint2_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M803.765 48.6C884.757 48.6 950.413 -18.2439 950.413 -100.7C950.413 -183.156 884.757 -250 803.765 -250C722.774 -250 657.117 -183.156 657.117 -100.7C657.117 -18.2439 722.774 48.6 803.765 48.6Z",
    fill: "url(#paint3_linear_12983_5150)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M631.97 116.6C656.002 116.6 675.483 96.7662 675.483 72.3C675.483 47.8338 656.002 28 631.97 28C607.939 28 588.457 47.8338 588.457 72.3C588.457 96.7662 607.939 116.6 631.97 116.6Z",
    fill: "url(#paint4_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M558.207 334.6C574.644 334.6 587.969 321.034 587.969 304.3C587.969 287.566 574.644 274 558.207 274C541.77 274 528.445 287.566 528.445 304.3C528.445 321.034 541.77 334.6 558.207 334.6Z",
    fill: "url(#paint5_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.348 239.6C400.785 239.6 414.11 226.034 414.11 209.3C414.11 192.566 400.785 179 384.348 179C367.911 179 354.586 192.566 354.586 209.3C354.586 226.034 367.911 239.6 384.348 239.6Z",
    fill: "url(#paint6_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.7176 269.8C88.3848 269.8 129.459 227.983 129.459 176.4C129.459 124.817 88.3848 83 37.7176 83C-12.9496 83 -54.0234 124.817 -54.0234 176.4C-54.0234 227.983 -12.9496 269.8 37.7176 269.8Z",
    fill: "url(#paint7_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.457 0.499207L412.736 -13.3008L476.09 46.1992L452.713 59.9992L389.457 0.499207Z",
    fill: "url(#paint8_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.709 -62.4012L431.988 -76.2012L412.736 -13.3012L389.457 0.498825L408.709 -62.4012Z",
    fill: "url(#paint9_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.092 -4.00078L521.469 -17.8008L490.037 84.9992L466.66 98.7992L498.092 -4.00078Z",
    fill: "url(#paint10_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76 -101.201L498.091 -4.00117L466.66 98.6988L363.328 1.59883L394.76 -101.201ZM452.712 59.9988L471.964 -2.90117L408.708 -62.4012L389.456 0.498825L452.712 59.9988Z",
    fill: "url(#paint11_linear_12983_5150)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.973 330.8L260.488 331.1L243.299 250.3L271.685 250L288.973 330.8Z",
    fill: "url(#paint12_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.766 320.1L150.281 320.3L255.184 201.3L283.571 201L178.766 320.1Z",
    fill: "url(#paint13_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.128 367.5L290.643 367.8L150.281 320.3L178.766 320.1L319.128 367.5Z",
    fill: "url(#paint14_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57 201L319.029 367.5L178.766 320.1L283.57 201ZM220.805 307.8L288.973 330.9L271.685 250L220.805 307.8Z",
    fill: "url(#paint15_linear_12983_5150)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1037.73 664C1173.62 664 1283.78 551.847 1283.78 413.5C1283.78 275.153 1173.62 163 1037.73 163C901.844 163 791.684 275.153 791.684 413.5C791.684 551.847 901.844 664 1037.73 664Z",
    fill: "url(#paint16_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1056.1 188.5L1032.92 202.5L969.074 143.6L992.255 129.6L1056.1 188.5Z",
    fill: "url(#paint17_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.44 251.6L1014.26 265.6L1032.92 202.5L1056.1 188.5L1037.44 251.6Z",
    fill: "url(#paint18_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.466 194L924.285 208L954.735 105L977.915 91L947.466 194Z",
    fill: "url(#paint19_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.78 290.2L1028.6 304.2L924.285 208L947.466 194L1051.78 290.2Z",
    fill: "url(#paint20_linear_12983_5150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.78 290.2L947.465 194.1L977.914 91L1082.23 187.1L1051.78 290.2ZM992.255 129.6L973.592 192.7L1037.44 251.6L1056.1 188.5L992.255 129.6Z",
    fill: "url(#paint21_linear_12983_5150)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12983_5150",
    x1: 46.4706,
    y1: 30.2647,
    x2: 1142.75,
    y2: 213.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B4149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12983_5150",
    x1: 47.453,
    y1: 30.2647,
    x2: 1143.73,
    y2: 213.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B4149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12983_5150",
    x1: 286.536,
    y1: -92.2787,
    x2: 497.639,
    y2: 115.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6008,
    stopColor: "#FAD9FF",
    stopOpacity: 0.3992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12983_5150",
    x1: 700.087,
    y1: -206.272,
    x2: 911.191,
    y2: 1.08165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6008,
    stopColor: "#FAD9FF",
    stopOpacity: 0.3992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12983_5150",
    x1: 601.219,
    y1: 40.928,
    x2: 663.892,
    y2: 102.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12983_5150",
    x1: 537.169,
    y1: 282.899,
    x2: 579.972,
    y2: 324.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B1AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12983_5150",
    x1: 363.308,
    y1: 187.884,
    x2: 406.11,
    y2: 229.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#003535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12983_5150",
    x1: -27.1172,
    y1: 110.257,
    x2: 150,
    y2: 286.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12983_5150",
    x1: 389.472,
    y1: 23.3404,
    x2: 476.06,
    y2: 23.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12983_5150",
    x1: 389.465,
    y1: -37.8604,
    x2: 431.973,
    y2: -37.8604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12983_5150",
    x1: 466.67,
    y1: 40.4852,
    x2: 521.45,
    y2: 40.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12983_5150",
    x1: 363.351,
    y1: -1.20146,
    x2: 498.131,
    y2: -1.20146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12983_5150",
    x1: 243.307,
    y1: 290.54,
    x2: 288.957,
    y2: 290.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12983_5150",
    x1: 150.305,
    y1: 260.636,
    x2: 283.525,
    y2: 260.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12983_5150",
    x1: 325.632,
    y1: 367.8,
    x2: 248.712,
    y2: 249.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B1AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12983_5150",
    x1: 380.88,
    y1: 317.767,
    x2: 210.104,
    y2: 231.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12983_5150",
    x1: 750.135,
    y1: 165.3,
    x2: 1219.15,
    y2: 582.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6008,
    stopColor: "#00CFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DCBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12983_5150",
    x1: 969.09,
    y1: 166.041,
    x2: 1056.07,
    y2: 166.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12983_5150",
    x1: 1014.27,
    y1: 227.041,
    x2: 1056.09,
    y2: 227.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12983_5150",
    x1: 924.295,
    y1: 149.486,
    x2: 977.897,
    y2: 149.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12983_5150",
    x1: 1056.69,
    y1: 304.2,
    x2: 900.852,
    y2: 225.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B1AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12983_5150",
    x1: 1141.65,
    y1: 230.7,
    x2: 964.935,
    y2: 159.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAppSetupBack);
export default __webpack_public_path__ + "static/media/img_app_setup_back.d1e8fabc13892dff568e6abdfe6da8ce.svg";
export { ForwardRef as ReactComponent };